// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../reason/next/Next.bs.js");
let React = require("react");
let FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
let Sentry = require("../../reason/Sentry.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let EventLogs = require("../../reason/EventLogs.bs.js");
let LoginForm = require("./LoginForm.bs.js");
let PageTitle = require("../../reason/common/PageTitle.bs.js");
let Responsive = require("../../uikit/reason/helpers/Responsive.bs.js");
let View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
let AuthSession = require("../../utils/AuthSession.bs.js");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let PasswordInput = require("./PasswordInput.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessage = require("../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
let Form__Checkbox = require("../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
let ContentBox__Jsx3 = require("../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let MobileInputTextSize = require("../../v5/common/Form/MobileInputTextSize.bs.js");
let EmailRegistrationStatus = require("../../v5/common/Query/EmailRegistrationStatus.bs.js");

function LoginPage(props) {
  let recordEvent = EventLogs.useRecordEvent();
  let router = Next.useRouter();
  let userRole = React.useRef(undefined);
  let nextParam = Next.Router.query(router)["next"];
  let msgParam = Next.Router.query(router)["msg"];
  let redirectRoute = userRole => Stdlib_Option.getOr(nextParam, userRole === "agent" ? "/" : "/client");
  React.useEffect(() => {
    if (nextParam !== undefined) {
      Next.Router.prefetch(Primitive_option.valFromOption(nextParam), router);
    } else {
      Next.Router.prefetch("/", router);
      Next.Router.prefetch("/client", router);
    }
  }, [nextParam]);
  let form = LoginForm.useForm({
    email: "",
    password: "",
    rememberMe: true
  }, {
    queryEmailAddress: EmailRegistrationStatus.queryFn
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    AuthSession.login(Scalars.EmailAddress.toString(param.email), param.password, param.rememberMe).then(x => {
      if (x.TAG === "Ok") {
        let data = x._0;
        let match = data.user;
        let role = match.role;
        userRole.current = role;
        notifyOnSuccess(undefined);
        if (!data.impersonated) {
          recordEvent([
            role === "agent" ? "USER" : "CLIENT",
            match.id
          ], undefined, "Login", undefined);
        }
        return Next.Router.push(redirectRoute(role), undefined, undefined, router);
      }
      let match$1 = x._0;
      if (typeof match$1 === "object") {
        Sentry.captureErrorMessage("Error in login response: " + match$1.VAL, true, undefined, "LoginPage.res", 63, undefined, undefined, undefined);
        return notifyOnFailure("An error occurred while logging in. Please try again or contact support");
      } else {
        return notifyOnFailure("Your email/password weren't recognized");
      }
    });
  });
  let serverMessage = form.status;
  let tmp;
  tmp = typeof serverMessage !== "object" || serverMessage.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(SystemMessage.make, {
      id: "form_submission",
      time: 5000,
      text: serverMessage._0,
      type_: "error",
      dismissible: true,
      secondary: true,
      handleOnDismiss: _id => form.dismissSubmissionResult()
    });
  let tmp$1;
  tmp$1 = msgParam === "password_change" ? JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(SystemMessage.make, {
        id: "login_success",
        time: 0,
        text: "Your password was changed successfully!",
        type_: "success",
        secondary: true,
        handleOnDismiss: _id => {}
      }),
      className: "mb-[16px]"
    }) : null;
  let match = form.emailResult;
  let tmp$2;
  if (match !== undefined && match.TAG !== "Validating") {
    let message = match._0;
    tmp$2 = message.TAG === "Ok" ? null : JsxRuntime.jsx(FormV5.$$Error.make, {
        children: message._0
      });
  } else {
    tmp$2 = null;
  }
  let match$1 = form.passwordResult;
  let tmp$3;
  tmp$3 = match$1 !== undefined && match$1.TAG !== "Ok" ? JsxRuntime.jsx(FormV5.$$Error.make, {
      children: match$1._0
    }) : null;
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: "Login to Top Agent Network"
      }),
      JsxRuntime.jsxs(ContentBox__Jsx3.make, {
        paddingFull: true,
        hasShadow: true,
        children: [
          tmp,
          tmp$1,
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                labelText: "Email",
                onChange: event => form.updateEmail((input, value) => ({
                  email: value,
                  password: input.password,
                  rememberMe: input.rememberMe
                }), event.target.value),
                onBlur: param => form.blurEmail(),
                status: Stdlib_Option.flatMap(form.emailResult, x => {
                  if (x.TAG === "Validating") {
                    return;
                  } else if (x._0.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: form.input.email
              }),
              tmp$2
            ]
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(PasswordInput.make, {
                onBlur: param => form.blurPassword(),
                onChange: event => form.updatePassword((input, value) => ({
                  email: input.email,
                  password: value,
                  rememberMe: input.rememberMe
                }), event.target.value),
                status: Stdlib_Option.map(form.passwordResult, x => {
                  if (x.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: form.input.password
              }),
              tmp$3
            ],
            className: "mt-[16px]"
          }),
          JsxRuntime.jsxs(View__Jsx3.make, {
            mt: "md",
            alignItems: Responsive.make("flexStart", "center", undefined, undefined, undefined, undefined, undefined),
            justifyContent: Responsive.make("flexStart", "spaceBetween", undefined, undefined, undefined, undefined, undefined),
            flexDirection: Responsive.make("column", "row", undefined, undefined, undefined, undefined, undefined),
            children: [
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: event => {
                  event.preventDefault();
                  form.updateRememberMe((input, value) => ({
                    email: input.email,
                    password: input.password,
                    rememberMe: value
                  }), !form.input.rememberMe);
                },
                checked: form.input.rememberMe,
                label: "Remember me"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                  href: "/reset_password",
                  children: "Forgot your password?"
                }),
                className: "mt-[8px] sm:mt-0"
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              disabled: !Stdlib_Option.getOr(form.valid(), false) || form.submitting,
              size: "medium",
              children: "Sign in"
            }),
            className: "mt-[32px] flex justify-end"
          })
        ]
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("p", {
            children: [
              "Not a member?  ",
              JsxRuntime.jsx("a", {
                children: "Request membership",
                href: "https://www.topagentnetwork.com/request-membership"
              }),
              " or ",
              JsxRuntime.jsx("a", {
                children: "learn more",
                href: "https://www.topagentnetwork.com"
              }),
              "."
            ]
          }),
          className: "text-center"
        }),
        className: "pt-[32px]"
      })
    ],
    className: MobileInputTextSize.className,
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let View;

let responsive = Responsive.make;

let make = LoginPage;

let $$default = LoginPage;

exports.View = View;
exports.responsive = responsive;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* Next Not a pure module */
